/// <reference path="skyward.base.extensions.js"/>
/// <reference path="skyward.ui.browse.js"/>
/// <reference path="skyward.ui.controls.js"/>
/// <reference path="skyward.ui.window.js"/>
/// <reference path="skyward.ui.workflow.js"/>
(
    function (skyward, $)
    {
        skyward.checkboxbrowse = skyward.checkboxbrowse || {};

        skyward.checkboxbrowse.getData = function (browse)
        {
            var data =
            {
                originalDefaultChecked: browse.originalDefaultChecked,
                defaultChecked: browse.defaultChecked,
                checkboxColumnHeaderText: browse.checkboxColumnHeaderText,
                checkboxColumnWidth: browse.checkboxColumnWidth,
                workflowVariableName: browse.workflowVariableName,
                serializedOverriddenCheckboxDatas: skyward.checkboxbrowse.getSerializedOverriddenCheckboxDatas(browse)
            };

            return data;
        };

        skyward.checkboxbrowse.getSerializedOverriddenCheckboxDatas = function (browse)
        {
            return browse.deserializedOverriddenCheckboxDatas !== undefined ? JSON.stringify(browse.deserializedOverriddenCheckboxDatas) : browse.serializedOverriddenCheckboxDatas;
        };

        var getOverriddenCheckboxData = function (browse)
        {
            if (browse.deserializedOverriddenCheckboxDatas)
            {
                if (browse.serializedOverriddenCheckboxDatas)
                {
                    browse.serializedOverriddenCheckboxDatas = undefined;
                }

                return browse.deserializedOverriddenCheckboxDatas;
            }

            var overriddenCheckboxData = JSON.parse(browse.serializedOverriddenCheckboxDatas);
            return overriddenCheckboxData ? overriddenCheckboxData : [];
        };

        var changeSelectAll = function (selectAllCheckbox, checkboxes, browse, newChecked)
        {
            selectAllCheckbox.prop("checked", newChecked);
            checkboxes.prop("checked", newChecked);

            selectAllCheckbox.prop("indeterminate", false);

            browse.deserializedOverriddenCheckboxDatas = [];
            browse.defaultChecked = newChecked;
        };

        var onCheckboxChange = function (event)
        {
            var checkbox = $(this);
            var browse = event.data.browse;
            var selectAllCheckbox = event.data.selectAllCheckbox;

            var id = checkbox.data('target-id');
            var overriddenCheckboxData = getOverriddenCheckboxData(browse);

            var checked = skyward.controls.getValue(checkbox);
            if (checked !== browse.defaultChecked)
            {
                var newData =
                {
                    Id: id
                };
                overriddenCheckboxData.push(newData);
            }
            else
            {
                for (var i = 0; i < overriddenCheckboxData.length; i++)
                {
                    if (overriddenCheckboxData[i].Id == id)
                    {
                        overriddenCheckboxData.splice(i, 1);
                        break;
                    }
                }
            }

            if (overriddenCheckboxData.length === 0)
            {
                changeSelectAll(selectAllCheckbox, event.data.checkboxes, browse, browse.defaultChecked);
            }
            else if (overriddenCheckboxData.length === parseInt(selectAllCheckbox.data('checkbox-count')))
            {
                changeSelectAll(selectAllCheckbox, event.data.checkboxes, browse, !browse.defaultChecked);
            }
            else
            {
                browse.deserializedOverriddenCheckboxDatas = overriddenCheckboxData;
                selectAllCheckbox.prop("indeterminate", true);
            }

            checkbox.focus();
        };

        var selectAllCheckboxIsIndeterminate = function (selectAllCheckbox, overriddenCheckboxData)
        {
            return (overriddenCheckboxData.length !== 0) && (overriddenCheckboxData.length !== parseInt(selectAllCheckbox.data('checkbox-count')));
        };

        var selectAllCheckboxIsChecked = function (selectAllCheckbox, overriddenCheckboxData, isIndeterminate)
        {
            isIndeterminate = (isIndeterminate === undefined) ? selectAllCheckboxIsIndeterminate(selectAllCheckbox, overriddenCheckboxData) : isIndeterminate;
            return !isIndeterminate && selectAllCheckbox.is(':checked');
        };

        var onSelectAllChange = function (event)
        {
            var selectAllCheckbox = $(this);

            var checkboxes = event.data.checkboxes;
            var browse = event.data.browse;

            var overriddenCheckboxData = getOverriddenCheckboxData(browse);

            var checked = selectAllCheckboxIsChecked(selectAllCheckbox, overriddenCheckboxData);

            changeSelectAll(selectAllCheckbox, checkboxes, browse, checked);
        };

        var init = function ()
        {
            var context = this;
            context.find('.checkboxBrowse').addBack('.checkboxBrowse').each(function ()
            {
                var checkboxBrowse = $(this);
                if (checkboxBrowse.data('checkboxBrowseLoaded') === true)
                {
                    return;
                }

                var browseName = checkboxBrowse.attr('id');
                checkboxBrowse.on('browseLoaded.' + browseName, function ()
                {
                    setup(checkboxBrowse);
                    checkboxBrowse.data('checkboxBrowseLoaded', true);
                });
            });
        };

        var setup = function (checkboxBrowse)
        {
            var browseName = checkboxBrowse.attr('id');
            var browse = skyward.browse.browseList[browseName];

            var selectAllCheckbox = checkboxBrowse.find('.selectAll');
            var checkboxes = checkboxBrowse.find('.rowSelectCheckbox').not(selectAllCheckbox);

            browse.deserializedOverriddenCheckboxDatas = undefined;

            selectAllCheckbox.off('click', onSelectAllChange);
            selectAllCheckbox.on('click', { browse: browse, checkboxes: checkboxes }, onSelectAllChange);

            checkboxBrowse.off('change', '.checkbox.checkboxBrowseContent.rowSelectCheckbox', onCheckboxChange);
            checkboxBrowse.on('change', '.checkbox.checkboxBrowseContent.rowSelectCheckbox', { browse: browse, checkboxes: checkboxes, selectAllCheckbox: selectAllCheckbox }, onCheckboxChange);
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
